import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import * as sortableListActions from '../../../actions/common/sortableListActions';

class SortableListLink extends React.Component{
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(direction) {
        let {
            action,
            listId,
            name:sort,
            actionParams,
            sortableList
        } = this.props;
        this.props.actions.updateList(listId, action, sort, direction, actionParams, sortableList.search, sortableList.withDeleted, sortableList.portalId);

    }

    isActive() {
        let {
            name,
            sortableList,
        } = this.props;

        return sortableList && (sortableList.column === name)
    }

    getDirectionIcon() {
        let {sortableList} = this.props;

        let icon = null;
        if(this.isActive()) {
            const direction = sortableList.asc
                ? 'down'
                : 'up';

            icon = <i className={classNames('fa', `fa-long-arrow-${direction}`)}/>;
        }

        return icon;
    }

    render() {
        let {
            title,
            name,
            sortableList,
        } = this.props;

        // if name doesn't set, this column not sortable
        if(!name) {
            return <span>{title}</span>;
        }

        let direction = 'ASC';
        // if is active column and sort type is asc
        if(sortableList && this.isActive() && sortableList.asc) {
            direction = 'DESC'
        }

        return <span onClick={(e) => this.onClick(direction)} className={classNames('text-primary', 'clickable')}>
            {title}&nbsp;
            {this.getDirectionIcon()}
        </span>;
    }
}

function mapStateToProps(state, ownProps) {
    return {
        sortableList: state.sortableList[ownProps.listId] || {},
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                sortableListActions
            ), dispatch)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SortableListLink);


// WEBPACK FOOTER //
// ./web/src/components/common/list/SortableColumn.jsx